<section class="styling-page">
    <avd-page-title
        title="Styling"
        imgSrc="./assets/images/Component-Styling-Getting-Started-128x82-v2d.png"
    ></avd-page-title>

    <div class="styling-page__header-row">
        <avd-code-example-header
            [packageName]="packageName"
            [storybookLink]="storybookLink"
            [repoLink]="repoLink"
        ></avd-code-example-header>
        <avd-theme-toggle-button></avd-theme-toggle-button>
    </div>
    <p>
        View ADS design token colors for background, text, icon, container,
        outline, data visualisation and overlay groups as well as typography
        tokens for font family weight, size and line height.
    </p>
    <uilab-mat-tab-group
        class="styling-page__tabs"
        [selectedIndex]="0"
        animationDuration="0ms"
        uilab-mat-align-tabs="start"
        uilab-mat-stretch-tabs="false"
    >
        <uilab-mat-tab label="Getting Started">
            <section class="styling-page__tab-content styling-page__section">
                <avd-styling-get-started></avd-styling-get-started>
            </section>
        </uilab-mat-tab>

        <uilab-mat-tab [label]="backgroundSection.title">
            <section class="styling-page__tab-content styling-page__section">
                <h2>{{ backgroundSection.title }}</h2>

                <section class="styling-page__subsection">
                    <h3>Background colors</h3>

                    <div class="styling-page__grid">
                        @for (
                            item of backgroundSection.items;
                            track item.cssVariable
                        ) {
                            <avd-background-color-card
                                [cssVariable]="item.cssVariable"
                                [label]="item.label"
                            ></avd-background-color-card>
                        }
                    </div>
                </section>

                <section class="styling-page__subsection">
                    <h3>Inverse background colors</h3>

                    <div class="styling-page__grid">
                        @for (
                            item of backgroundSection.items;
                            track item.inverseCssVariable
                        ) {
                            @if (item.inverseCssVariable) {
                                <avd-background-color-card
                                    [cssVariable]="item.inverseCssVariable"
                                    [label]="item.label"
                                ></avd-background-color-card>
                            }
                        }
                    </div>
                </section>

                <section class="styling-page__subsection">
                    <h3>{{ appBackgroundSection.title }}</h3>

                    <div class="styling-page__grid">
                        @for (
                            item of appBackgroundSection.items;
                            track item.cssVariable
                        ) {
                            <avd-background-color-card
                                [cssVariable]="item.cssVariable"
                                [label]="item.label"
                            ></avd-background-color-card>
                        }
                    </div>
                </section>
            </section>
        </uilab-mat-tab>

        <uilab-mat-tab [label]="textSection.title">
            <section class="styling-page__tab-content styling-page__section">
                <h2>{{ textSection.title }}</h2>

                <section class="styling-page__subsection">
                    <h3>Text colors</h3>

                    <div class="styling-page__grid">
                        @for (
                            item of textSection.items;
                            track item.cssVariable
                        ) {
                            <avd-text-color-card
                                [cssVariable]="item.cssVariable"
                                [label]="item.label"
                            ></avd-text-color-card>
                        }
                    </div>
                </section>

                <section class="styling-page__subsection">
                    <h3>Inverse text colors</h3>

                    <div class="styling-page__grid">
                        @for (
                            item of textSection.items;
                            track item.inverseCssVariable
                        ) {
                            @if (item.inverseCssVariable) {
                                <avd-text-color-card
                                    [cssVariable]="item.inverseCssVariable"
                                    [inverseMode]="true"
                                    [label]="item.label"
                                ></avd-text-color-card>
                            }
                        }
                    </div>
                </section>
            </section>
        </uilab-mat-tab>

        <uilab-mat-tab [label]="iconSection.title">
            <section class="styling-page__tab-content styling-page__section">
                <h2>{{ iconSection.title }}</h2>

                <section class="styling-page__subsection">
                    <h3>Icon colors</h3>

                    <div class="styling-page__grid">
                        @for (
                            item of iconSection.items;
                            track item.cssVariable
                        ) {
                            <avd-icon-color-card
                                [cssVariable]="item.cssVariable"
                                [label]="item.label"
                            ></avd-icon-color-card>
                        }
                    </div>
                </section>

                <section class="styling-page__subsection">
                    <h3>Inverse icon colors</h3>

                    <div class="styling-page__grid">
                        @for (
                            item of iconSection.items;
                            track item.inverseCssVariable
                        ) {
                            @if (item.inverseCssVariable) {
                                <avd-icon-color-card
                                    [cssVariable]="item.inverseCssVariable"
                                    [inverseMode]="true"
                                    [label]="item.label"
                                ></avd-icon-color-card>
                            }
                        }
                    </div>
                </section>
            </section>
        </uilab-mat-tab>

        <uilab-mat-tab [label]="outlineSection.title">
            <section class="styling-page__tab-content styling-page__section">
                <h2>{{ outlineSection.title }}</h2>

                <section class="styling-page__subsection">
                    <h3>Outline colors</h3>

                    <div class="styling-page__grid">
                        @for (
                            item of outlineSection.items;
                            track item.cssVariable
                        ) {
                            <avd-outline-color-card
                                [cssVariable]="item.cssVariable"
                                [label]="item.label"
                            ></avd-outline-color-card>
                        }
                    </div>
                </section>

                <section class="styling-page__subsection">
                    <h3>Inverse outline colors</h3>

                    <div class="styling-page__grid">
                        @for (
                            item of outlineSection.items;
                            track item.inverseCssVariable
                        ) {
                            @if (item.inverseCssVariable) {
                                <avd-outline-color-card
                                    [cssVariable]="item.inverseCssVariable"
                                    [inverseMode]="true"
                                    [label]="item.label"
                                ></avd-outline-color-card>
                            }
                        }
                    </div>
                </section>
            </section>
        </uilab-mat-tab>

        <uilab-mat-tab [label]="containerSection.title">
            <section class="styling-page__tab-content styling-page__section">
                <h2>{{ containerSection.title }}</h2>

                <section class="styling-page__subsection">
                    <h3>{{ containerSection.regularTitle }}</h3>

                    <div class="styling-page__grid">
                        @for (
                            item of containerSection.regularItems;
                            track item.cssVariable
                        ) {
                            <avd-container-color-card
                                [cssVariable]="item.cssVariable"
                                [label]="item.label"
                            ></avd-container-color-card>
                        }
                    </div>
                </section>

                <section class="styling-page__subsection">
                    <h3>Inverse {{ containerSection.regularTitle }}</h3>

                    <div class="styling-page__grid">
                        @for (
                            item of containerSection.regularItems;
                            track item.inverseCssVariable
                        ) {
                            @if (item.inverseCssVariable) {
                                <avd-container-color-card
                                    [cssVariable]="item.inverseCssVariable"
                                    [inverseMode]="true"
                                    [label]="item.label"
                                ></avd-container-color-card>
                            }
                        }
                    </div>
                </section>

                <section class="styling-page__subsection">
                    <h3>{{ containerSection.solidTitle }}</h3>

                    <div class="styling-page__grid">
                        @for (
                            item of containerSection.solidItems;
                            track item.cssVariable
                        ) {
                            <avd-container-color-card
                                [cssVariable]="item.cssVariable"
                                [label]="item.label"
                            ></avd-container-color-card>
                        }
                    </div>
                </section>

                <section class="styling-page__subsection">
                    <h3>Inverse {{ containerSection.solidTitle }}</h3>

                    <div class="styling-page__grid">
                        @for (
                            item of containerSection.solidItems;
                            track item.inverseCssVariable
                        ) {
                            @if (item.inverseCssVariable) {
                                <avd-container-color-card
                                    [cssVariable]="item.inverseCssVariable"
                                    [inverseMode]="true"
                                    [label]="item.label"
                                ></avd-container-color-card>
                            }
                        }
                    </div>
                </section>
            </section>
        </uilab-mat-tab>

        <uilab-mat-tab label="Elevation">
            <section class="styling-page__tab-content styling-page__section">
                <h2>Elevation</h2>

                <section class="styling-page__subsection">
                    <h3>{{ elevatedContainerSection.title }}</h3>

                    <div class="styling-page__grid">
                        @for (
                            item of elevatedContainerSection.items;
                            track item.cssVariable
                        ) {
                            <avd-elevated-container-color-card
                                [cssVariable]="item.cssVariable"
                                [boxShadowCssVariable]="
                                    item.boxShadowCssVariable ?? ''
                                "
                                [label]="item.label"
                            ></avd-elevated-container-color-card>
                        }
                    </div>
                </section>

                <section class="styling-page__subsection">
                    <h3>Inverse {{ elevatedContainerSection.title }}</h3>

                    <div class="styling-page__grid">
                        @for (
                            item of elevatedContainerSection.items;
                            track item.inverseCssVariable
                        ) {
                            @if (item.inverseCssVariable) {
                                <avd-elevated-container-color-card
                                    [cssVariable]="item.inverseCssVariable"
                                    [boxShadowCssVariable]="
                                        item.boxShadowCssVariable ?? ''
                                    "
                                    [label]="item.label"
                                ></avd-elevated-container-color-card>
                            }
                        }
                    </div>
                </section>
            </section>
        </uilab-mat-tab>

        <uilab-mat-tab [label]="overlaySection.title">
            <section class="styling-page__tab-content styling-page__section">
                <h2>{{ overlaySection.title }}</h2>

                <section class="styling-page__subsection">
                    <div class="styling-page__grid">
                        @for (
                            item of overlaySection.items;
                            track item.cssVariable
                        ) {
                            <avd-overlay-color-card
                                [cssVariable]="item.cssVariable"
                                [label]="item.label"
                            ></avd-overlay-color-card>
                        }
                    </div>
                </section>

                <section class="styling-page__subsection">
                    <h3>Inverse overlay colors</h3>

                    <div class="styling-page__grid">
                        @for (
                            item of overlaySection.items;
                            track item.inverseCssVariable
                        ) {
                            @if (item.inverseCssVariable) {
                                <avd-overlay-color-card
                                    [cssVariable]="item.inverseCssVariable"
                                    [label]="item.label"
                                ></avd-overlay-color-card>
                            }
                        }
                    </div>
                </section>
            </section>
        </uilab-mat-tab>

        <uilab-mat-tab [label]="dataVisSection.title">
            <section class="styling-page__tab-content styling-page__section">
                <h2>{{ dataVisSection.title }}</h2>

                <section class="styling-page__subsection">
                    <h3>Data visualisation colors</h3>

                    <div
                        class="styling-page__grid styling-page__grid--full-width"
                    >
                        @for (item of dataVisSection.items; track item.tint) {
                            <avd-data-vis-color-chart-card
                                [label]="item.label"
                                [tint]="item.tint"
                            ></avd-data-vis-color-chart-card>
                        }
                    </div>
                </section>

                <section class="styling-page__subsection">
                    <h3>Inverse data visualisation colors</h3>

                    <div
                        class="styling-page__grid styling-page__grid--full-width"
                    >
                        @for (item of dataVisSection.items; track item.tint) {
                            <avd-data-vis-color-chart-card
                                [label]="item.label"
                                [tint]="item.tint"
                                [inverseMode]="true"
                            ></avd-data-vis-color-chart-card>
                        }
                    </div>
                </section>
            </section>
        </uilab-mat-tab>

        <uilab-mat-tab label="Typography tokens">
            <section class="styling-page__tab-content styling-page__section">
                <h2>Typography tokens</h2>

                <section class="styling-page__subsection">
                    <h3>{{ typographySection.defaultTitle }}</h3>

                    <div class="styling-page__grid">
                        @for (
                            item of typographySection.defaultItems;
                            track item.cssVariable
                        ) {
                            <avd-typography-token-card
                                [cssVariable]="item.cssVariable"
                                [label]="item.label"
                                [longhandSnippet]="item.longhandSnippet"
                                [shorthandSnippet]="item.shorthandSnippet"
                            ></avd-typography-token-card>
                        }
                    </div>
                </section>

                <section class="styling-page__subsection">
                    <h3>{{ typographySection.editorialTitle }}</h3>

                    <div class="styling-page__grid">
                        @for (
                            item of typographySection.editorialItems;
                            track item.cssVariable
                        ) {
                            <avd-typography-token-card
                                [cssVariable]="item.cssVariable"
                                [label]="item.label"
                                [longhandSnippet]="item.longhandSnippet"
                                [shorthandSnippet]="item.shorthandSnippet"
                            ></avd-typography-token-card>
                        }
                    </div>
                </section>

                <section class="styling-page__subsection">
                    <h3>{{ typographySection.appTitle }}</h3>

                    <div class="styling-page__grid">
                        @for (
                            item of typographySection.appItems;
                            track item.cssVariable
                        ) {
                            <avd-typography-token-card
                                [cssVariable]="item.cssVariable"
                                [label]="item.label"
                                [longhandSnippet]="item.longhandSnippet"
                                [shorthandSnippet]="item.shorthandSnippet"
                            ></avd-typography-token-card>
                        }
                    </div>
                </section>
            </section>
        </uilab-mat-tab>
    </uilab-mat-tab-group>
</section>
